﻿import { RioSeverity } from "../enums/Severity";

export class RioValidationApiModel {
    severity: RioSeverity;
    resourceName: string;
}